import { abyssColors } from '@/theme/colors';

export const menuItemSelectedStyle = {
  width: '0.2rem',
  height: '2.2rem',
  backgroundColor: abyssColors.primary[300],
  position: 'absolute',
  left: '1px',
};

export const sortButtonStyle = {
  width: '10rem',
  height: '3.4rem',
  borderRadius: '4px',
  border: `1px solid ${abyssColors.primary[200]}`,
  padding: '0.8rem 0.6rem',
  marginLeft: '1.2rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.6rem',
};

export const sortButtonTextStyle = {
  fontSize: '1.4rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const textBoxStyle = {
  width: 'auto',
  maxWidth: '7rem',
  minWidth: '4.6rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const sortingIconStyle = {
  width: '1.8rem',
  height: '1.8rem',
};

export const sortTextStyle = {
  color: abyssColors.primary[500],
  fontWeight: '500',
  fontSize: '1.2rem',
  px: '0.8rem',
  py: '0.4rem',
};
